var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-fit-content bg-color-9 color-white open-sans-bold nowrap",staticStyle:{"font-size":"0.75rem","padding":"0.11rem 0.41rem","border-radius":"2px"}},[_vm._v(" "+_vm._s(_vm.$t("rsf_new"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }